import { httpClient } from '../../utils/http-client';
import 'uuid';
let subtitles;
export const setSubgroupSentences = (subgroupSentences) => {
    subtitles = subgroupSentences;
};
export default class CompilationService {
    video;
    sentences;
    addVideo(video) {
        this.video = video;
        return this;
    }
    addSubtitles(sentences) {
        this.sentences = sentences;
        return this;
    }
    extractWordsFromSelectedSentences() {
        if (!this.video)
            throw 'Video undefined';
        if (!this.sentences)
            throw 'No sentences selected';
        if (!this.video.transcription)
            throw 'Video has no transcription';
        //console.log('Extracting words from selected sentences', this.sentences);
        const combined = this.sentences.map(sentence => {
            return sentence.words.map(word => ({
                ...this.video.transcription.transcription[word.index],
                index: word.index,
                sentenceIndex: sentence.index
            }));
        });
        return combined;
    }
    async checkStatus(identifier) {
        const response = await httpClient.get('/compile/' + identifier);
        return response.data;
    }
    async prepare(identifier, draft) {
        //console.log ('[Compile prepare] identifier:', identifier, 'draft:', draft);
        const response = await httpClient.post('/compile', {
            video: this.video,
            sentences: this.extractWordsFromSelectedSentences(),
            nextSentence: identifier,
            draft
        });
        return response.data;
    }
}
